import React, { useState, useEffect, useRef } from 'react';
import { Tooltip, ClickAwayListener, tooltipClasses, styled } from '@mui/material';

let globalTooltipId = null; // shared across instances

// Custom styled Tooltip with wide max-width
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 1500, // or whatever max width you want
    backgroundColor: 'transparent',
    color: '#000',
    boxShadow: 'none',
    backdropFilter: 'none',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'transparent',
  }
}));

export function CustomTooltipCell({ value, tooltipContent }) {
  const [open, setOpen] = useState(false);
  const tooltipId = useRef(Symbol("tooltip"));

  const handleClick = (e) => {
    e.stopPropagation(); // prevent triggering row selection
    if (globalTooltipId !== tooltipId.current) {
      globalTooltipId = tooltipId.current;
      setOpen(true);
      window.dispatchEvent(new CustomEvent("tooltip-close-all", { detail: tooltipId.current }));
    } else {
      setOpen((prev) => !prev);
    }
  };

  const handleClickAway = () => {
    setOpen(false);
    if (globalTooltipId === tooltipId.current) {
      globalTooltipId = null;
    }
  };

  useEffect(() => {
    const listener = (e) => {
      if (e.detail !== tooltipId.current) {
        setOpen(false);
      }
    };
    window.addEventListener("tooltip-close-all", listener);
    return () => {
      window.removeEventListener("tooltip-close-all", listener);
    };
  }, []);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div onClick={handleClick} style={{ cursor: 'pointer', width: '100%' }}>
        <CustomWidthTooltip
          title={tooltipContent}
          open={open}
          disableHoverListener
          disableFocusListener
          disableTouchListener
          arrow
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
          }}
        >
          <span style={{ display: 'inline-block', width: '100%' }}>
            {value}
          </span>
        </CustomWidthTooltip>
      </div>
    </ClickAwayListener>
  );
}
